(() => {
  const list = document.querySelector('.pw-ai-faq__list');
  if (!list || list.querySelectorAll('.pw-ai-faq__item').length <= 6) return;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'pw-mobile-faq-toggle';
  button.setAttribute('aria-expanded', 'false');
  button.textContent = 'Voir les autres questions';
  list.after(button);
  list.classList.add('pw-mobile-faq-ready');

  button.addEventListener('click', () => {
    const expanded = list.classList.toggle('pw-mobile-faq-expanded');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Réduire les questions' : 'Voir les autres questions';
  });
})();
